<template>
  <!--<div id="app">-->
    <!--<div id="nav">-->
      <!--<router-link to="/">Home</router-link> |-->
      <!--<router-link to="/about">About</router-link>-->
    <!--</div>-->
    <!--<router-view/>-->
  <!--</div>-->
  <div id="wrapper" v-if="!$route.meta.loginLayout">
    <Navigation/>
    <div id="page-wrapper" class="gray-bg">
      <Header />
      <router-view/>
      <Footer/>
    </div>
  </div>
  <div v-else-if="$route.meta.loginLayout">
    <router-view/>
  </div>
</template>

<script>
    /* eslint-disable */

    import Navigation from '@/components/layout_components/Navigation'
    import Header from '@/components/layout_components/Header'
    import Footer from '@/components/layout_components/Footer'
    export default {
        name: 'App',
        data() {
            return {
                messagingObject: null
            }
        },
        components: {
            Navigation,
            Header,
            Footer
        },
        created: function () {
            this.$http.interceptors.request.use((request) => {
                const token = 'Bearer '+ this.$store.getters.accessToken;
                if(request.headers.Authorization !== undefined && request.headers.Authorization !== token) {
                  request.headers.Authorization = token;
                }
                Pace.start();
                return request;
            }, (error) => {
                return Promise.reject(error);
            });
            this.$http.interceptors.response.use((response) => {
                Pace.stop();
                return response;
            }, (error) => {
                Pace.stop();
                const status = (error && error.response) ? error.response.status : null;
                const config = error ? error.config : null;

                if(status === 401 /*&& !originalRequest._retry*/) {
                  console.log("In Error In 401 Interceptor");
                  return this.updateRefreshToken(config);
                }else {
                  return Promise.reject(error);
                }
            });
        },
        mounted: function () {
            document.title = "Delivery Monsters - Portal";
            if(this.$store.state.user.userRolesById !== undefined && this.$store.state.user.userRolesById[0].role.split('_')[1] === 'BRANCH'){
                if (this.$store.state.user.branch && this.$store.state.user.branch.isPortalEnabled) {
                  this.$store.dispatch('validateUserAndCreateWebsocketConnection');
                    // this.$store.dispatch("initFCM").then(messaging => {
                    //     console.log("Initialized...");
                    // }).catch(ex => {
                    //     swal("Warning", "Please allow notifications in browser!" + ex, "warning");
                    //     console.log("Ex", ex);
                    // })
                }
            }


        }
    }
</script>


<style >
  .select2-container{
    z-index: 10000 !important;
  }
  .dataTables_processing{
    position: absolute;
    right: 50%;
    top: 50%;
    margin-top: 10px;
  }
  /*.table-responsive{*/
    /*overflow-x: initial !important;*/
  /*}*/

  @media only screen and (min-width: 1281px) {
    .table-responsive {
      overflow-x: initial !important;
    }
  }
  .form-control {
    height: 40px !important;
  }
</style>
